/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_GenderInputs */

const en_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender`)
};

/**
* | output |
* | --- |
* | "Gender" |
*
* @param {Field_GenderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_gender = /** @type {((inputs?: Field_GenderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_GenderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_gender(inputs)
});